import React, {Component} from 'react';
import axios from 'axios';
import { FaCreditCard } from "react-icons/fa";
import { Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import BreadcrumbCustomer from "../../Layout/user/BreadcrumbCustomer";

class RechargeCreditComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            error: false,
            messageError: '',
            errorForm: false,
            messageErrorForm: '',
            isNotification: '',
            textNotification: '',
            configSystem: {},
            amount: 0,
            textAmount: '0',
            infoPayment: {},
            btnSubmit: false,
        }
    }

    componentDidMount() {
        document.querySelector('.cr-sidebar').classList.add('cr-sidebar--open');
        this.props.updateUrlRedirect({ url: window.location.href })
        window.scrollTo(0, 0);
        this.getConfigPayment();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getConfigPayment = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/payment/getConfigPayment',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        configSystem: ref.data.content,
                        loadPage: false,
                        isLoading: false,
                        infoPayment: ref.data.content.methods[0],
                        amount: ref.data.content.min,
                        textAmount: this.addCommas(ref.data.content.min),
                    })

                    let item = {
                        credit: ref.data.credit
                    }
                    this.props.updateCredit(item);
                } else {
                    if ( ref.data.error > 9000 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu hệ thống thất bại',
                })
            })
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        for (let index = 1; index < 10; index++) {
            value = value.replace('.', '');
            value = value.replace(',', '');
        }
        // console.log(name, value)
        this.setState({
            [name]: value,
            textAmount: this.addCommas(value)
        })
    }

    changeMethodPayment = (keyAction) => {
        let infoPayment = this.state.infoPayment;
        let configSystem = this.state.configSystem;
        configSystem.methods.forEach( (method, key) => {
            if (key === keyAction) {
                method.checked = true;
                infoPayment = method;
            } else {
                method.checked = false;
            }
        })
        this.setState({
            configSystem: configSystem,
            infoPayment: infoPayment
        })
    }

    loadMethodPayment = () => {
        if ( this.state.configSystem.methods.length ) {
            return (
                this.state.configSystem.methods.map( (method, key) => (
                    <div className="col-md-4 text-center" key={key}>
                        <div className="form-group clearfix">
                            <div className="icheck-primary d-inline">
                                <input type="radio" name="method_pay" id={"bank_transfer_" + method.setting} checked={ method.checked }
                                       onChange={ () => this.changeMethodPayment(key) }
                                />
                                <label htmlFor={"bank_transfer_" + method.setting} />
                            </div>
                            <div className="title-payment-momo mt-4">
                                <img src={ method.image } alt="Thanh toán qua" />
                                <br /><br />
                                <label htmlFor="bank_transfer">
                                    { method.text_method }
                                </label>
                            </div>
                        </div>
                    </div>
                ))
            )
        }
    }

    submit = () => {
        this.setState({
            btnSubmit: true,
            loadPage: true,
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let form = {
            amount: this.state.amount,
            methodPayment: this.state.infoPayment.setting,
        };
        // console.log(form)
        axios.post( process.env.REACT_APP_API_URL + '/api/payment/rechargeCredit', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    this.redirect( ref.data.paymentId );
                } else {
                    if (ref.data.error > 9000) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            btnSubmit: false,
                            errorForm: true,
                            messageErrorForm: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    btnSubmit: false,
                    loadPage: false,
                    isLoading: false,
                    errorForm: true,
                    messageErrorForm: 'Tạo đơn đặt hàng thất bại',
                })
            })
    }

    redirect = (paymentId) => {
        this.props.notification({
            isNotification: true,
            textNotification: 'Yêu cầu nạp tiền vào tài khoản thành công'
        });
        this.props.shouldRedirect(paymentId);
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Thanh toán trực tuyến"} page={"Thanh toán trực tuyến"}
                                        icon={<FaCreditCard className="breadcrumb-icon"/>}/>
                            <Card>
                                <CardBody>
                                    {
                                        this.state.error ? (
                                            <>
                                                <Alert color="danger">
                                                    { this.state.messageError }
                                                </Alert>
                                            </>
                                        ) : (
                                            <>
                                                <div className="form-info">
                                                    <h4>Thông tin giao dịch</h4>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            {
                                                                this.state.errorForm ? (
                                                                    <>
                                                                        <Alert color="danger">
                                                                            { this.state.messageErrorForm }
                                                                        </Alert>
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                        </div>
                                                        <div className="col-md-12">
                                                            <strong className="text-danger">Lưu ý</strong>
                                                            <ul>
                                                                <li className="text-danger">
                                                                    Số tiền nạp vào tối thiểu:
                                                                    <strong> { this.state.configSystem.textMinRechange }</strong>
                                                                </li>
                                                                <li className="text-danger">
                                                                    Hạn mức giao dịch của tài khoản:
                                                                    <strong> { this.state.configSystem.textMaxCredit }</strong>
                                                                </li>
                                                            </ul>
                                                            <div className="mt-2">
                                                                <div className="row form-group">
                                                                    <div className="col-md-3">
                                                                        <label>Họ và tên</label>
                                                                    </div>
                                                                    <div className="col-md-9">
                                                                        { this.props.user.name }
                                                                    </div>
                                                                </div>
                                                                <div className="row form-group">
                                                                    <div className="col-md-3">
                                                                        <label>Email</label>
                                                                    </div>
                                                                    <div className="col-md-9">
                                                                        { this.props.user.email }
                                                                    </div>
                                                                </div>
                                                                <div className="row form-group">
                                                                    <div className="col-md-3">
                                                                        <label>Số dư tài khoản</label>
                                                                    </div>
                                                                    <div className="col-md-9">
                                                                        { this.addCommas(this.props.credit) }
                                                                    </div>
                                                                </div>
                                                                <div className="row form-group">
                                                                    <div className="col-md-3">
                                                                        <label>Số tiền nạp</label>
                                                                    </div>
                                                                    <div className="col-md-9">
                                                                        <input type="text" className="form-control"
                                                                               name="amount"
                                                                               value={ this.state.textAmount } onChange={ this.changeInput }
                                                                               min={ this.state.configSystem.min }
                                                                               max={ this.state.configSystem.max }
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row form-group mt-4">
                                                                    <div className="col-md-3">
                                                                        <label>Thanh toán qua</label>
                                                                    </div>
                                                                    <div className="row col-md-9">
                                                                        {
                                                                            this.loadMethodPayment()
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="row form-group mt-4">
                                                                    <div className="col-md-3">
                                                                        <label>Thông tin tài khoản</label>
                                                                    </div>
                                                                    <div className="row col-md-9">
                                                                        <div className="info-company">
                                                                            <div className="info-bank"><b>
                                                                                Bank Name:</b> { this.state.infoPayment.setting } <br />
                                                                                <b>Account Name:</b> { this.state.infoPayment.account } <br />
                                                                                <b>Account Number:</b> { this.state.infoPayment.code } <br />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 text-center">
                                                        <button className="btn btn-primary" onClick={ () => this.submit() } disabled={ this.state.btnSubmit }>
                                                            Tiến hành thanh toán
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    }
                                </CardBody>
                            </Card>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerRechargeCredit' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
        updateUrlRedirect: (item) => {
            dispatch(({ type : 'updateUrlRedirect', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(RechargeCreditComponent);